import { BaseError as d, decodeErrorResult as u } from "viem";
import { waitForTransactionReceipt as h, getTransaction as R, call as l } from "viem/actions";
const i = "unknown reason", f = [
  {
    type: "error",
    name: "Error",
    inputs: [{ name: "message", type: "string" }]
  }
], p = "0x08c379a0", c = (t) => {
  const a = t == null ? void 0 : t.data;
  return typeof a == "string" && a.startsWith(p);
}, g = (t) => {
  if (!(t instanceof d))
    return null;
  const a = t.walk(c);
  if (c(a))
    try {
      const { args: n } = u({
        abi: f,
        data: a.data
      });
      return String(n[0]);
    } catch {
    }
  const r = t.details || "";
  return r.startsWith("execution reverted") ? r.replace(/^execution reverted:?\s*/, "") || i : null;
}, w = async (t, a) => {
  const r = await R(t, {
    hash: a.transactionHash
  }), n = {
    account: r.from,
    to: r.to ?? void 0,
    data: r.input,
    value: r.value,
    gas: r.gas
  };
  for (const e of [a.blockNumber - BigInt(1), void 0])
    try {
      await l(
        t,
        e === void 0 ? n : { ...n, blockNumber: e }
      );
    } catch (o) {
      const s = g(o);
      if (s)
        return s;
    }
  return i;
}, y = async (t, a) => {
  const { chainId: r, hash: n } = a, e = t.getClient({ chainId: r }), o = await h(e, { hash: n });
  if (o.status === "reverted")
    throw new Error(await w(e, o));
  return { ...o, chainId: e.chain.id };
};
export {
  g as getRevertReason,
  y as waitForTransactionReceiptWithReason
};
//# sourceMappingURL=waitForTransactionReceiptWithReason.js.map
